export default __webpack_public_path__ + "static/media/ic_sri_lanka.2a8f6354.svg";